<ng-container *ngIf="show">

	<ngb-toast
        header="Información"
        [delay]="5000"
		[autohide]="autohide"
		(mouseenter)="autohide = false"
		(mouseleave)="autohide = true"
		(hidden)="hideEvent()"
		[class.bg-success]="autohide"
		[class.text-white]="autohide"

	>
        <h6>{{info.infoMessage | translate}}</h6>
        
        <ul class="list-group" *ngIf="info.messages !== undefined && info.messages !== null && info.messages.length !== 0">
          <li class="list-group-item" *ngFor="let cause of info.messages">{{cause | translate}}</li>
        </ul>

    </ngb-toast>

</ng-container>

